import {
  HttpBackend,
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreditCardTypeResponse } from '@app/core/models/openpay.model';
import {
  ICreditCard,
  IPaymentParams,
  ICreatePaymentResponse,
  IRequestPaymentParams,
  IRequestPaymentResponse,
  IRequestPayments,
  IRequestPaymentsConfig,
} from '@app/core/models/payments.model';
import { environment } from '@environment';

import { Observable } from 'rxjs';
import { URLS } from './url.constants';
import { HandleTokenService } from '@core/services/handle-token.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentsAPI {
  public _httpClient = new HttpClient(this._httpBackend);
  private API_URL = environment.api_url;
  constructor(
    private _http: HttpClient,
    public _httpBackend: HttpBackend,
    private _handleTokenService: HandleTokenService
  ) {}

  public getCreditCardType(bines: string): Observable<HttpResponse<CreditCardTypeResponse>> {
    const baseUrl = environment.openpay_url;
    const merchantid: string = environment.openpay_merchant_id;
    return this._http.get<CreditCardTypeResponse>(
      `${baseUrl}${merchantid}/bines/${bines}/promotions`,
      { observe: 'response' }
    );
  }

  public createCreditCard(creditCard: ICreditCard): Observable<void> {
    return this._http.post<void>(`${URLS.CREATE_CREDIT_CARD}`, creditCard);
  }

  public createPayments(paymentParams: IPaymentParams): Observable<ICreatePaymentResponse> {
    return this._http.post<ICreatePaymentResponse>(
      `/app/transactions/${paymentParams.transaction_id}/payments`,
      paymentParams
    );
  }

  private _setHeaders(transactionToken):
    | HttpHeaders
    | {
        [header: string]: string | string[];
      } {
    return {
      'Content-Type': 'application/json',
      Authorization: `Token: ${transactionToken}`,
    };
  }

  public requestPayments(
    requestPaymentParams: IRequestPaymentParams
  ): Observable<IRequestPaymentResponse> {
    const token = this._handleTokenService.getAccessToken();
    const options = {
      headers: this._setHeaders(token),
    };
    return this._httpClient.get<IRequestPaymentResponse>(
      `${this.API_URL}/app/transactions/${requestPaymentParams.transaction_id}/payments/${requestPaymentParams.payment_id}`,
      options
    );
  }

  public updateRedirectFlag(
    requestPaymentParams: IRequestPaymentParams,
    was_redirected: boolean
  ): Observable<{}> {
    return this._http.patch<IRequestPaymentResponse>(
      `/app/transactions/${requestPaymentParams.transaction_id}/payments/${requestPaymentParams.payment_id}`,
      { was_redirected: was_redirected }
    );
  }

  public checkPendingPayments(
    transactionId: string,
    filters?: IRequestPaymentsConfig
  ): Observable<IRequestPayments> {
    let params = new HttpParams();
    params = params.appendAll({ ...filters });
    return this._http.get<IRequestPayments>(`/app/transactions/${transactionId}/payments`, {
      params,
    });
  }
}
